import { usePwaViewportWidth } from "../../hooks/useScreenWidth";
import { RootContainer } from "../../styles/Container.style";
import { Image } from "../Informations.page";

export default function FaqPage() {
  const viewportWidth = usePwaViewportWidth();

  return (
    <RootContainer $alignItem="center">
      <Image $width={viewportWidth + "px"} src="/informations/faq.png" />
    </RootContainer>
  );
}
